import React from 'react';

//components
import FeaturedItem from './FeaturedItem';
import LoadMore from '../generalComponents/LoadMore';
import { RootStoreContext } from '../../context';
import vaultImg1 from '../../assets/vault/naked-news-premium-snapchat-f726a45f.png';

class FeaturedItems extends React.Component {
    static contextType = RootStoreContext;
    renderSnapchatBanner = () => (
        <div className="content-item-container main">
            <a
                className="content-item "
                title="Naked News Premium Snapchat"
                href="https://fancentro.com/thenakednews"
                target="_blank"
                rel="noopener noreferrer"
            >
                <div className="content-item-thumbnail">
                    <img
                        src={vaultImg1}
                        alt="Xlthumb placeholder"
                        style={{ opacity: 1 }}
                    />
                </div>
                <div className="content-item-caption">
                    <div className="content-item-category">Naked Notes</div>
                    <div className="content-item-title">
                        Naked News Premium Snapchat
                    </div>
                </div>
            </a>
        </div>
    );

    render() {
        const {
            featuredItems,
            loadMore,
            isLoading,
            typeOfListing,
            showLoadMoreButton,
            cams
        } = this.props;
        const featuredItemsFirstList = featuredItems.filter(
            (item, index) => index < 6
        );
        const featuredItemsSecondList = featuredItems.filter(
            (item, index) => index > 6
        );
        const isTitleForHome = window.location.pathname;
        const { loggedInUser } = this.context;
        return (
            <div className="content">
                <div className="container">
                {isTitleForHome === '/home' ? (<div className="news-title">
                      <h3><a href="/featured-content">FEATURED CONTENT</a></h3>
                      <div />    
                  </div>
                  ) :  (<h1 className="h1 title">Featured Content</h1>)
                }
                    <div className="content-grid-container">
                        <div className="content-grid">
                            {featuredItemsFirstList.map((link, index) => (
                                <FeaturedItem key={index} featuredItem={link} loggedInUser={loggedInUser} />
                            ))}
                            {featuredItemsSecondList.map((link, index) => (
                                <FeaturedItem key={index} featuredItem={link} loggedInUser={loggedInUser} />
                            ))}
                        </div>
                        {/*<div>
                            <div className="cams-title">Naked News Cams</div>
                            <div className="row live-cams-container">
                                <iframe
                                    src="https://as.sexad.net/as/if?p=nakednews&w=100&h=100&v=5186"
                                    data-src="https://as.sexad.net/as/if?p=nakednews&w=100&h=100&v=5186"
                                    align="middle"
                                    allowtransparency="true"
                                    width="100%"
                                    height="100%"
                                    marginHeight="0"
                                    marginWidth="0"
                                    frameBorder="0"
                                    scrolling="no">
                                </iframe>
                            </div>
                        </div>*/}
                       
                    </div>
                    {showLoadMoreButton && (
                        <LoadMore loadMore={loadMore} isLoading={isLoading} />
                    )}
                </div>
            </div>
        );
    }
}
export default FeaturedItems;
